<template>
  <div v-if="show" class="modal-overlay" @click="$emit('close')">
    <div class="modal" @click.stop>
      <div class="modal-header">
        <h2>More Info About These Chats</h2>
        <button class="modal-close" @click="$emit('close')">&times;</button>
      </div>
      <div class="modal-content">
        <p>In February 2025, a significant leak exposed the internal communications of the Black Basta ransomware group, revealing over 200,000 messages exchanged between September 2023 and September 2024.</p> <br />
        <p>The leak, attributed to a user known as "ExploitWhispers," was reportedly motivated by Black Basta's controversial decision to target Russian banks, a move that breached an unspoken rule among Russian cybercriminals to avoid domestic targets. The disclosed chats unveiled internal conflicts, including disputes over leadership, financial misconduct, and operational disagreements, leading to the group's decline.</p><br />
        <p>Key figures such as alleged leader Oleg Nefedov (aka "GG" or "Trump") were implicated, with some members accused of collecting ransoms without providing decryption tools. The logs also detailed the group's tactics, including the exploitation of vulnerabilities in enterprise technologies like Citrix and Fortinet, use of tools such as Cobalt Strike, and reliance on platforms like ZoomInfo for victim profiling.</p><br />
        <p>Following the leak, Black Basta's operations dwindled, with reports indicating that members have migrated to other ransomware groups like Cactus and Akira, continuing their cybercriminal activities under different banners. </p><br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatInfoModal',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(13, 26, 63, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal {
  background-color: var(--background);
  border: 1px solid var(--message-border);
  border-radius: 8px;
  padding: 20px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.modal::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h2 {
  margin: 0;
  color: var(--primary);
}

.modal-close {
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-content {
  color: var(--text-primary);
  line-height: 1.6;
}
</style> 